import api from './api';

// 文章相關的 API 函數
export const articleApi = {
  // 獲取文章列表
  getArticles: async (params = {}) => {
    try {
      const response = await api.get('/articles/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 獲取管理員文章列表（包含未發布文章）
  getManageArticles: async () => {
    try {
      const response = await api.get('/articles/manage/');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 獲取單篇文章
  getArticle: async (idOrSlug, bySlug = false) => {
    try {
      const response = bySlug
        ? await api.get(`/articles/slug/${idOrSlug}/`)
        : await api.get(`/articles/${idOrSlug}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 建立文章
  createArticle: async (articleData) => {
    try {
      const response = await api.post('/articles/', articleData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 更新文章
  updateArticle: async (id, articleData) => {
    try {
      const response = await api.put(`/articles/${id}/`, articleData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 刪除文章
  deleteArticle: async (id) => {
    try {
      await api.delete(`/articles/${id}/`);
    } catch (error) {
      throw error;
    }
  },

  // 更新文章排序
  updateArticleOrder: async (articleOrders) => {
    try {
      const response = await api.post('/articles/update-order/', { article_orders: articleOrders });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 獲取標籤列表
  getTags: async () => {
    try {
      const response = await api.get('/articles/tags/');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 上傳文章內容圖片
  uploadContentImage: async (imageFile) => {
    try {
      const formData = new FormData();
      formData.append('image', imageFile);
      
      const response = await api.post('/articles/upload-content-image/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default articleApi;
